import React, { useEffect, useRef, useState } from "react";
import { Plus, Minus } from "lucide-react";
import { Reveal } from "../hooks/useReveal";

const FAQS = [
  { q: "What is XPTY?", a: "XPTY is Xylapay’s Platinum Real World Asset token." },
  { q: "What does one XPTY represent?", a: "One XPTY represents 10 milligrams of Platinum." },
  { q: "How many XPTY equal one gram of Platinum?", a: "100 XPTY represent one gram of Platinum." },
  { q: "What is XylaFi Platinum?", a: "XylaFi Platinum is the product identity for Xylapay’s XPTY Platinum Real World Asset token." },
  { q: "Which blockchain is XPTY built on?", a: "XPTY uses Solana infrastructure." },
];

function Item({ q, a }) {
  const [open, setOpen] = useState(false);
  const contentRef = useRef(null);
  const [maxH, setMaxH] = useState(0);

  useEffect(() => {
    const measure = () => {
      if (contentRef.current) setMaxH(contentRef.current.scrollHeight);
    };
    measure();
    window.addEventListener("resize", measure);
    return () => window.removeEventListener("resize", measure);
  }, [open, a]);

  return (
    <div className="border-b hairline">
      <button
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center justify-between gap-6 py-6 text-left group"
        aria-expanded={open}
      >
        <span className="text-[17px] sm:text-[19px] font-medium text-[#F1F2EF] group-hover:text-white transition-colors duration-200">
          {q}
        </span>
        <span className="shrink-0 text-[#A0A5A2] group-hover:text-[#F1F2EF] transition-colors duration-200">
          {open ? <Minus size={18} strokeWidth={1.75} /> : <Plus size={18} strokeWidth={1.75} />}
        </span>
      </button>
      <div
        style={{
          maxHeight: open ? `${maxH}px` : "0px",
          opacity: open ? 1 : 0,
          transition: "max-height 0.4s ease, opacity 0.4s ease",
        }}
        className="overflow-hidden"
      >
        <p
          ref={contentRef}
          className="pb-6 pr-10 text-[15px] sm:text-[16px] leading-[1.6] text-[#A0A5A2] max-w-[600px]"
        >
          {a}
        </p>
      </div>
    </div>
  );
}

export default function FAQ() {
  return (
    <section id="faq" className="w-full py-[80px] lg:py-[140px]">
      <div className="mx-auto max-w-[1280px] px-5 sm:px-8 lg:px-[64px]">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <Reveal>
              <span className="micro-label">FAQ</span>
              <h2 className="mt-5 text-[32px] sm:text-[42px] lg:text-[52px] font-medium tracking-[-0.02em] leading-[1.05] text-[#F1F2EF]">
                Questions, answered.
              </h2>
            </Reveal>
          </div>
          <div className="lg:col-span-7 lg:col-start-6">
            <Reveal delay={0.08}>
              <div className="border-t hairline">
                {FAQS.map((f) => (
                  <Item key={f.q} q={f.q} a={f.a} />
                ))}
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
